import { render, staticRenderFns } from "./feesbreakdownreport.vue?vue&type=template&id=0ac05160&"
import script from "./feesbreakdownreport.vue?vue&type=script&lang=js&"
export * from "./feesbreakdownreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports